/** Handle enum for unauthorize response 401 code */
export enum UnthorizedAccessType {
  CREDENTIAL_MISMATCH = 0,
  WAN_BLOCK = 1,
  AUTHORIZATION_EMPTY_HEADER = 2,
  INVALID_ACESS_TOKEN = 3,
  USER_EXPIRED = 4,
  USER_NOT_YET_VALID = 5,
}
